import React from "react";
import "../styles/Footer.css";

const PHONE_DISPLAY = "(331) 600-4935";
const PHONE_LINK = "tel:+13316004935";

const Footer = () => {
  return (
    <footer className="site-footer">
        <p className="footer-name">AT Appliance Repair and Maintenance</p>
        <p>Family-owned appliance repair serving Plainfield, Naperville and the western suburbs since 2016.</p>
        <p>
          Plainfield, IL 60586<br />
          <a href={PHONE_LINK}>{PHONE_DISPLAY}</a><br />
          {/* Swap in a domain email once it's set up, e.g. service@atappliancemaster.com */}
          <a href="mailto:altantransit@gmail.com">altantransit@gmail.com</a><br />
          Open Monday–Sunday, 8 a.m.–9 p.m.
        </p>
        <p className="footer-links">
          <a href="/">Home</a> · <a href="/services">Our Services</a> · <a href="/serviceareas">Service Areas</a> ·{" "}
          <a href="/services/commercial-appliance-repair">Commercial Repair</a> · <a href="/contact">Contact Us</a> · <a href="/blog">Blog</a>
        </p>
        <p>© 2016 AT Appliance Repair and Maintenance LLC</p>
      </footer>
      
  );
};

export default Footer;